import { gql } from '@apollo/client';

const UPDATE_LISTING = gql`
  mutation Mutation($updateListingId: String) {
    updateListing(id: $updateListingId)
  }
`;

export { UPDATE_LISTING };
